<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Buttons</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                
                <div class="buttons-section-main float-l width-full"> <!--button main section-->

                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 float-l"> <!--general button-->     
                        <div  class="row">
                            <div class="button-box general-button bg-color-ffffff radius-5 border-d3dee3 default-bx-shadow float-l width-full mr-20">          
                                <h5 class="color-666666 font-text-regular-san width-full float-l mb-30"> General Buttons </h5>

                                <div class="mr-17 pb-2 float-l" >
                                    <b-button size="sm" variant="primary">
                                        Primary
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l" >
                                    <b-button size="sm" variant="secondary">
                                        Secondary
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l" >
                                    <b-button size="sm" variant="success">
                                        Success
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l" >
                                    <b-button size="sm" variant="warning">
                                        Warning
                                    </b-button>
                                </div>

                                <div class="pb-2 float-l" >
                                    <b-button size="sm" variant="danger">
                                        Danger
                                    </b-button>
                                </div>

                            </div>
                        </div> 
                    </div> <!--general button-->

                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 float-l"> <!--outline button-->     
                        <div  class="row">
                            <div class="button-box outline-button bg-color-ffffff radius-5 border-d3dee3 default-bx-shadow float-l width-full ml-20">          
                                <h5 class="color-666666 font-text-regular-san width-full float-l mb-30"> Button with outline </h5>

                                <div class="mr-17 pb-2 float-l" >
                                    <b-button size="sm" variant="primary">
                                        Primary
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l" >
                                    <b-button size="sm" variant="secondary">
                                        Secondary
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l" >
                                    <b-button size="sm" variant="success">
                                        Success
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l" >
                                    <b-button size="sm" variant="warning">
                                        Warning
                                    </b-button>
                                </div>

                                <div class="pb-2 float-l" >
                                    <b-button size="sm" variant="danger">
                                        Danger
                                    </b-button>
                                </div>

                            </div>
                        </div> 
                    </div> <!--outline button-->

                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 float-l mt-40"> <!--ronded button-->     
                        <div  class="row">
                            <div class="button-box general-button rounded-button bg-color-ffffff radius-5 border-d3dee3 default-bx-shadow float-l width-full mr-20">          
                                <h5 class="color-666666 font-text-regular-san width-full float-l mb-30"> Rounded Buttons </h5>

                                <div class="mr-17 pb-2 float-l" >
                                    <b-button size="sm" variant="primary">
                                        Primary
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l" >
                                    <b-button size="sm" variant="secondary">
                                        Secondary
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l" >
                                    <b-button size="sm" variant="success">
                                        Success
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l" >
                                    <b-button size="sm" variant="warning">
                                        Warning
                                    </b-button>
                                </div>

                                <div class="pb-2 float-l" >
                                    <b-button size="sm" variant="danger">
                                        Danger
                                    </b-button>
                                </div>

                            </div>
                        </div> 
                    </div> <!--ronded button--> 

                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 float-l mt-40"> <!--Rounded outline button-->     
                        <div  class="row">
                            <div class="button-box rounded-button outline-button bg-color-ffffff radius-5 border-d3dee3 default-bx-shadow float-l width-full ml-20">          
                                <h5 class="color-666666 font-text-regular-san width-full float-l mb-30"> Rounded outlined Buttons </h5>

                                <div class="mr-17 pb-2 float-l" >
                                    <b-button size="sm" variant="primary">
                                        Primary
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l" >
                                    <b-button size="sm" variant="secondary">
                                        Secondary
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l" >
                                    <b-button size="sm" variant="success">
                                        Success
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l" >
                                    <b-button size="sm" variant="warning">
                                        Warning
                                    </b-button>
                                </div>

                                <div class="pb-2 float-l" >
                                    <b-button size="sm" variant="danger">
                                        Danger
                                    </b-button>
                                </div>

                            </div>
                        </div> 
                    </div> <!--Rounded outline button--> 

                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 float-l mt-40"> <!--Button sizes -->     
                        <div  class="row">
                            <div class="button-box general-button button-size bg-color-ffffff radius-5 border-d3dee3 default-bx-shadow float-l width-full mr-20">          
                                <h5 class="color-666666 font-text-regular-san width-full float-l mb-30"> Button Sizes </h5>

                                <div class="mr-17 pb-2 float-l btn-primary-large">
                                    <b-button size="lg" variant="primary">
                                        Primary
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l btn-primary-secondary mt-7" >
                                    <b-button size="sm" variant="secondary">
                                        Secondary
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l btn-primary-s mt-11" >
                                    <b-button size="sm" variant="success">
                                        Small Button
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l btn-primary-tiny mt-13" >
                                    <b-button size="sm" variant="warning">
                                        Tiny Button
                                    </b-button>
                                </div>

                            </div>
                        </div> 
                    </div> <!--Button sizes -->

                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 float-l mt-40"> <!--Rounded Buttons sizes -->     
                        <div  class="row">
                            <div class="button-box general-button rounded-button button-size bg-color-ffffff radius-5 border-d3dee3 default-bx-shadow float-l width-full ml-20">          
                                <h5 class="color-666666 font-text-regular-san width-full float-l mb-30"> Button Sizes with Rounded </h5>

                                <div class="mr-17 pb-2 float-l btn-primary-large">
                                    <b-button size="lg" variant="primary">
                                        Primary
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l btn-primary-secondary mt-7" >
                                    <b-button size="sm" variant="secondary">
                                        Secondary
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l btn-primary-s mt-11" >
                                    <b-button size="sm" variant="success">
                                        Small Button
                                    </b-button>
                                </div>

                                <div class="mr-17 pb-2 float-l btn-primary-tiny mt-13" >
                                    <b-button size="sm" variant="warning">
                                        Tiny Button
                                    </b-button>
                                </div>

                            </div>
                        </div> 
                    </div> <!--Rounded Buttons sizes -->

                    <div class="col-12 float-l mt-40"> <!--button with icon-->     
                        <div  class="row">
                            <div class="bg-color-ffffff radius-5 border-d3dee3 button-box default-bx-shadow float-l width-full mr-20">          
                                <h5 class="color-666666 font-text-regular-san width-full float-l mb-30"> Button with Icon </h5>

                                <div class="btn-icon-left general-button col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9 float-l"> <!--left section-->
                                    <div class="row">

                                        <div class="btn-icon-top float-l width-full"> <!--top section-->
                                            <div class="mr-17 pb-2 float-l" >
                                                <b-button size="sm" variant="primary">
                                                    <span> Primary </span> <i class="hi-icon icon-abmarrow-point-to-right"></i>
                                                </b-button>
                                            </div>

                                            <div class="mr-17 pb-2 float-l" >
                                                <b-button size="sm" variant="secondary">
                                                    <span> Secondary </span> <i class="hi-icon icon-abmarrow-point-to-right"></i>
                                                </b-button>
                                            </div>

                                            <div class="mr-17 pb-2 float-l" >
                                                <b-button size="sm" variant="success">
                                                    <span> Success </span> <i class="hi-icon icon-abmcheck-mark"></i>
                                                </b-button>
                                            </div>

                                            <div class="mr-17 pb-2 float-l" >
                                                <b-button size="sm" variant="warning">
                                                    <span> Warning </span> <i class="hi-icon icon-abmwarning"></i>
                                                </b-button>
                                            </div>

                                            <div class="mr-17 pb-2 float-l" >
                                                <b-button size="sm" variant="danger">
                                                    <span> Danger </span> <i class="hi-icon icon-abmalert"></i>
                                                </b-button>
                                            </div>

                                            <div class="pb-2 float-l mail-icon-btn" >
                                                <b-button size="sm" variant="primary">
                                                    <i class="hi-icon icon-abmenvelope"></i> <span> Mail </span> 
                                                </b-button>
                                            </div>
                                        </div> <!--top section-->

                                        <div class="btn-icon-top rounded-button float-l width-full mt-15"> <!--bottom section-->
                                            <div class="mr-17 pb-2 float-l" >
                                                <b-button size="sm" variant="primary">
                                                    <span> Primary </span> <i class="hi-icon icon-abmarrow-point-to-right"></i>
                                                </b-button>
                                            </div>

                                            <div class="mr-17 pb-2 float-l" >
                                                <b-button size="sm" variant="secondary">
                                                    <span> Secondary </span> <i class="hi-icon icon-abmarrow-point-to-right"></i>
                                                </b-button>
                                            </div>

                                            <div class="mr-17 pb-2 float-l" >
                                                <b-button size="sm" variant="success">
                                                    <span> Success </span> <i class="hi-icon icon-abmcheck-mark"></i>
                                                </b-button>
                                            </div>

                                            <div class="mr-17 pb-2 float-l" >
                                                <b-button size="sm" variant="warning">
                                                    <span> Warning </span> <i class="hi-icon icon-abmwarning"></i>
                                                </b-button>
                                            </div>

                                            <div class="mr-17 pb-2 float-l" >
                                                <b-button size="sm" variant="danger">
                                                    <span> Danger </span> <i class="hi-icon icon-abmalert"></i>
                                                </b-button>
                                            </div>

                                            <div class="pb-2 float-l mail-icon-btn mail-icon-btn-radius" >
                                                <b-button size="sm" variant="primary">
                                                    <i class="hi-icon icon-abmenvelope"></i> <span> Mail </span> 
                                                </b-button>
                                            </div>
                                        </div> <!--bottom section-->

                                    </div>                            
                                </div> <!--left section-->

                                <div class="btn-icon-right col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 float-l"> <!--right section-->
                                    <div class="row">

                                        <div class="dropdown-small col-6 float-l">
                                            <div class="row">
                                                <b-dropdown id="ddown1" text="Action" class="m-md-2">
                                                    <b-dropdown-item>Action</b-dropdown-item>
                                                    <b-dropdown-item>Another Action</b-dropdown-item>
                                                    <b-dropdown-item>Something else here</b-dropdown-item>
                                                </b-dropdown>
                                            </div>
                                        </div>

                                        <div class="dropdown-large col-6 float-l">
                                            <div class="row">
                                                <b-dropdown id="ddown1" text="Action" class="mt-9">
                                                    <b-dropdown-item>Action</b-dropdown-item>
                                                    <b-dropdown-item>Another Action</b-dropdown-item>
                                                    <b-dropdown-item>Something else here</b-dropdown-item>
                                                </b-dropdown>
                                            </div>
                                        </div>

                                    </div>
                                </div> <!--right section-->

                                <div class="pagination-manual-main float-l col-12 mt-50">
                                    <div class="row">
                                        <h5 class="color-666666 font-text-regular-san width-full float-l mb-30"> Button toolbar pagination </h5>
                                        <div class="">
                                            <b-pagination align="center" :total-rows="100" v-model="currentPage" :per-page="10">
                                            </b-pagination>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div> 
                    </div> <!--button with icon-->   

                </div> <!--button main section-->

            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/footer';
    import { Button } from 'bootstrap-vue/es/components';
    import { Pagination } from 'bootstrap-vue/es/components';
    import { Card } from 'bootstrap-vue/es/components';
    import { Dropdown } from 'bootstrap-vue/es/components';
    export default {
        name: 'Center',
        components: {
            'app-backend-footer': BackendFooter,

        },
        data() {
            return {
                dismissSecs: 10,
                dismissCountDown: 0,
                showDismissibleAlert: false
            }

        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            showAlert() {
                this.dismissCountDown = this.dismissSecs
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/buttons.vue